import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import { Text } from "@ubnt/ui-components/Text";
import styled, { css } from "styled-components";

export const TitleSectionContainer = styled.div<{
  $spacing?: { top?: number; bottom?: number };
  $isCentered?: boolean;
  $shouldApplyMobileSpacings?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 50%;
  min-width: fit-content;

  ${({ $isCentered }) =>
    $isCentered &&
    css`
      align-items: center;
      max-width: 100%;

      ${StyledTitle} {
        text-align: center;
      }
    `}

  ${({ $spacing, $shouldApplyMobileSpacings }) =>
    $spacing &&
    css`
      padding-top: ${$spacing.top}px;
      padding-bottom: ${$spacing.bottom}px;

      ${$shouldApplyMobileSpacings &&
      css`
        @media ${BREAKPOINTS.TABLET_AND_DOWN} {
          padding-top: ${$spacing.top * 0.75}px;
          padding-bottom: ${$spacing.bottom * 0.75}px;
        }
      `}
    `}

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    max-width: 100%;
    text-align: center;
  }
`;

export const StyledTitle = styled.h2<{
  $titleWeight?: number;
  $isLeftAligned?: boolean;
  $isMainTitle?: boolean;
  $isOtherLanguage?: boolean;
}>`
  margin: 0;
  color: ${({ theme }) => theme.colors.text1};
  font-size: 30px;
  font-weight: 700;
  line-height: normal;
  text-wrap: pretty;

  span {
    vertical-align: middle;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    font-size: 28px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    padding: 0 8px;

    ${({ $isOtherLanguage }) =>
      $isOtherLanguage &&
      css`
        word-break: break-word;
      `}
  }

  ${({ $titleWeight }) =>
    $titleWeight &&
    css`
      font-weight: ${$titleWeight} !important;
    `}

  ${({ $isLeftAligned }) =>
    $isLeftAligned &&
    css`
      text-align: left;
    `}

  ${({ $isMainTitle }) =>
    $isMainTitle &&
    css`
      font-size: 42px;
      font-weight: 700;
      line-height: normal;

      @media ${BREAKPOINTS.TABLET_AND_DOWN} {
        font-size: 36px;
        line-height: 40px;
      }
    `}
`;

export const StyledDescription = styled(Text)<{
  $isSmallDescription: boolean;
  $isLeftAligned?: boolean;
  $descriptionMaxWidth?: number;
}>`
  line-height: 26px;
  text-wrap: pretty;
  color: ${({ theme }) => theme.colors.neutral08};

  ${({ $isLeftAligned }) =>
    $isLeftAligned &&
    css`
      text-align: left;
    `}

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    font-size: 16px;
    line-height: normal;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    br {
      display: none;
    }
  }

  ${({ $isSmallDescription }) =>
    $isSmallDescription &&
    css`
      font-size: 16px;
      line-height: 24px;
    `}

  ${({ $descriptionMaxWidth }) =>
    $descriptionMaxWidth &&
    css`
      max-width: ${$descriptionMaxWidth}px;
    `}
`;
